import { PaymentMethods } from '../../shared/ui';
import { useAuth } from '../auth/AuthProvider';

export const Footer = () => {
  const { openAuthModal } = useAuth();

  return (
    <footer className="bg-stone-950 text-stone-400 py-20 px-6">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-12">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-8">
            <img src="/moon-footer.png" alt="" width={32} height={32} className="w-8 h-8" />
            <span className="font-sans font-semibold text-stone-50 text-xl tracking-tight">
              HDMAVEN.XYZ
            </span>
          </div>
          <p className="max-w-xs leading-relaxed">
            “To be ‘awake’ is really mundane. It’s what we’re supposed to be. It’s not some high
            exalted state that we have to suffer to get to. That’s nonsense. We just haven’t had the
            education until now”
          </p>
        </div>
        <div>
          <h4 className="text-stone-50 font-medium mb-6">Navigation</h4>
          <ul className="space-y-4 text-sm">
            <li>
              <a href="#" className="hover:text-stone-50 transition-colors">
                Home
              </a>
            </li>
            <li>
              <a href="#services" className="hover:text-stone-50 transition-colors">
                Services
              </a>
            </li>
            <li>
              <a href="#about" className="hover:text-stone-50 transition-colors">
                About
              </a>
            </li>
            <li>
              <a href="#network" className="hover:text-stone-50 transition-colors">
                Network &amp; Referrals
              </a>
            </li>
            <li>
              <a href="#gift" className="hover:text-stone-50 transition-colors">
                Gift a Reading
              </a>
            </li>
            <li>
              <a href="/blog" className="hover:text-stone-50 transition-colors">
                Blog
              </a>
            </li>
            <li>
              <a
                href="#contact"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-stone-50 transition-colors"
              >
                Contact
              </a>
            </li>
            <li>
              <button
                onClick={() => openAuthModal()}
                className="hover:text-stone-50 transition-colors text-left"
              >
                Client Access
              </button>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-stone-50 font-medium mb-6">Legal</h4>
          <ul className="space-y-4 text-sm">
            <li>
              <a
                href="#privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-stone-50 transition-colors"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href="#terms"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-stone-50 transition-colors"
              >
                Terms & Conditions
              </a>
            </li>
            <li>
              <a
                href="#birth-data-disclaimer"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-stone-50 transition-colors"
              >
                Birth Data Disclaimer
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-20 pt-8 border-t border-stone-900">
        <div className="flex justify-center mb-8">
          <PaymentMethods tone="dark" />
        </div>
        <div className="text-xs flex justify-between">
          <span>© {new Date().getFullYear()} HDMAVEN.XYZ. All rights reserved.</span>
          <div className="flex gap-6">
            <a href="#" className="hover:text-stone-50">
              Instagram
            </a>
            <a href="#" className="hover:text-stone-50">
              Telegram
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
